import { RefreshCw } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';

import { formatLastUpdated } from '../../model/format-last-updated';

type Props = {
    dataUpdatedAt: number | undefined;
    isRefreshing: boolean;
    onRefresh: () => void;
};

// Disabled while `isRefreshing` so a repeat click queues no second read. `dataUpdatedAt`
// is undefined pre-first-success, so the stamp is withheld but the refresh action still renders.
export function ReportingPageFreshnessBar({ dataUpdatedAt, isRefreshing, onRefresh }: Props) {
    return (
        <div className="flex items-center gap-1 text-sm">
            {dataUpdatedAt !== undefined && <span>{formatLastUpdated(dataUpdatedAt)}</span>}
            <Button
                type="button"
                variant="ghost"
                size="icon"
                aria-label="Refresh reporting data"
                disabled={isRefreshing}
                onClick={onRefresh}
            >
                <RefreshCw className={cn(isRefreshing && 'animate-spin')} aria-hidden="true" />
            </Button>
        </div>
    );
}
